import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _BackButton, _Footer, _ToggleCollapseButton;
import { useEffect, useState } from 'react';
import classNames from 'clsx';
import { useSidebar } from "../sidebar-context";
import { BackButton } from "./back-button";
import { Footer, ToggleCollapseButton } from "./components";
import { Header } from "./components/header";
import { MenuLinks } from "./menu-links";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var SIDEBAR_EXPANDED_WIDTH = '256px';
export var SIDEBAR_COLLAPSED_WIDTH = '112px';
export var SidebarMenu = function SidebarMenu(_ref) {
  var className = _ref.className,
    fullWidth = _ref.fullWidth;
  var _useSidebar = useSidebar(),
    sidebarCollapsed = _useSidebar.sidebarCollapsed,
    isDark = _useSidebar.isDark,
    menuLinks = _useSidebar.menuLinks,
    currentModule = _useSidebar.currentModule,
    currentSingleRoute = _useSidebar.currentSingleRoute,
    onClickModule = _useSidebar.onClickModule,
    onClickItem = _useSidebar.onClickItem,
    isLoading = _useSidebar.isLoading,
    isSidebarAnimationEnabled = _useSidebar.isSidebarAnimationEnabled,
    sidebarType = _useSidebar.sidebarType,
    organizationSlug = _useSidebar.organizationSlug;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSliding = _useState2[0],
    setIsSliding = _useState2[1];
  var _useState3 = useState(currentModule),
    _useState4 = _slicedToArray(_useState3, 2),
    displayedModule = _useState4[0],
    setDisplayedModule = _useState4[1];
  useEffect(function () {
    if (currentModule !== displayedModule && isSidebarAnimationEnabled) {
      setIsSliding(true);
      var timer = setTimeout(function () {
        setDisplayedModule(currentModule);
        setIsSliding(false);
      }, 300); // 300ms matches the animation duration
      return function () {
        return clearTimeout(timer);
      };
    } else {
      setDisplayedModule(currentModule);
    }
  }, [currentModule, displayedModule, isSidebarAnimationEnabled]);
  var containerClasses = classNames(className, 'tw-flex tw-flex-col tw-flex-shrink-0 z-6 tw-relative tw-h-screen sm:tw-h-full tw-border-solid tw-border-[1px] tw-transition-[width] tw-ease-in-out tw-duration-150', 'md:tw-h-[calc(100vh-63px)]', isDark ? 'tw-bg-elevation-dark-01 tw-border-elevation-dark-04' : 'tw-bg-neutral-light-100 tw-border-neutral-light-300', {
    'tw-flex-col tw-items-center': sidebarCollapsed,
    'tw-w-full': fullWidth,
    'tw-w-[11.2rem]': !fullWidth && sidebarCollapsed,
    'tw-w-[25.6rem]': !fullWidth && !sidebarCollapsed
  });
  var itemsToRender = displayedModule ? displayedModule.children : menuLinks;
  var contentClasses = classNames('tw-overflow-y-auto tw-flex-grow', {
    'tw-transition-transform tw-duration-300 tw-ease-in-out': isSidebarAnimationEnabled,
    'tw-pt-1.6': !displayedModule,
    'tw-translate-x-0': !isSliding || !isSidebarAnimationEnabled,
    '-tw-translate-x-full': isSliding && isSidebarAnimationEnabled
  });
  return /*#__PURE__*/_jsxs("div", {
    className: containerClasses,
    children: [displayedModule && (_BackButton || (_BackButton = /*#__PURE__*/_jsx(BackButton, {}))), /*#__PURE__*/_jsxs("div", {
      className: contentClasses,
      children: [displayedModule && /*#__PURE__*/_jsx(Header, {
        module: displayedModule
      }), /*#__PURE__*/_jsx(MenuLinks, {
        links: itemsToRender,
        currentSingleRoute: currentSingleRoute,
        onClickModule: onClickModule,
        onClickItem: onClickItem,
        isLoading: isLoading,
        sidebarType: sidebarType,
        organizationSlug: organizationSlug
      })]
    }), _Footer || (_Footer = /*#__PURE__*/_jsx(Footer, {})), _ToggleCollapseButton || (_ToggleCollapseButton = /*#__PURE__*/_jsx(ToggleCollapseButton, {}))]
  });
};